export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('AlignmentOptions', (options, id) => {
        const container = document.getElementById(id);

        const tailwindClasses = {
          center: 'md:items-center',
          start: 'md:items-start',
          end: 'md:items-end',
        }[options.value];

        container.classList.add(tailwindClasses);
      });
    });
  },
};
